import React from "react";
import {SkeletonWrapper} from "../../dashboard/stats/SkeletonWrapper";
import Skeleton from "react-loading-skeleton";

export const CategoriesSkeleton = () => {

    const renderCategories = () => {
        return Array.from({length: 7}).map((_, index) => (
            <Skeleton key={index} height={50} style={{marginBottom: 15}}/>
        ));
    }

    return (
        <SkeletonWrapper>
            <div className={'scrollable-y-wrapper'}>
                {renderCategories()}
            </div>
        </SkeletonWrapper>
    );
}